"use strict";

require("@ci/polyfills");
require('@creditinfo-ui/fonts/open-sans.css');